import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export function tooltipTemplate(
  this: TefComs4csMicroFrontend,
  stylecontext: string,
  title: string,
  description: string,
) {
  // The "O2" in our service responses must be replaced by "o2" to trigger
  // the "Air" font ligature for the "o2"
  const descriptionFixed = description.replace('O2', 'o2');

  return html`<one-popover cloak context="${stylecontext}" placement="bottom">
    <one-link as="span" color="prominent" strong>${unsafeHTML(descriptionFixed)}</one-link>
    <div slot="content">
      ${unsafeHTML(title)}
    </div>
    </one-popover>`;
}
